module.exports = __webpack_public_path__ + "media/Notification.mp3";